const DEFAULT_TIMEZONE = 'Africa/Accra'

const AGENCY_TIMEZONES = {
  STRANSITGHA: 'Africa/Accra',
  GPRTU: 'Africa/Accra',
  PROTOA: 'Africa/Accra'
}

const AGENCY_COUNTRY_IDS = {
  STRANSITGHA: 'GHA',
  GPRTU: 'GHA',
  PROTOA: 'GHA'
}

function normalizeAgencyId (agencyId) {
  return String(agencyId || '').trim().toUpperCase()
}

function getTimezoneByAgencyId (agencyId) {
  const normalizedAgencyId = normalizeAgencyId(agencyId)
  return AGENCY_TIMEZONES[normalizedAgencyId] || DEFAULT_TIMEZONE
}

function getCountryIdByAgencyId (agencyId) {
  const normalizedAgencyId = normalizeAgencyId(agencyId)
  return AGENCY_COUNTRY_IDS[normalizedAgencyId] || null
}

function getAgencyIdsByCountryId (countryId) {
  const normalizedCountryId = String(countryId || '').trim().toUpperCase()
  if (!normalizedCountryId) {
    return []
  }

  return Object.keys(AGENCY_COUNTRY_IDS).filter((agencyId) => {
    return AGENCY_COUNTRY_IDS[agencyId] === normalizedCountryId
  })
}

module.exports = {
  DEFAULT_TIMEZONE,
  AGENCY_TIMEZONES,
  AGENCY_COUNTRY_IDS,
  normalizeAgencyId,
  getTimezoneByAgencyId,
  getCountryIdByAgencyId,
  getAgencyIdsByCountryId
}
